import React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import BaseSwiper from '@src/components/swiper/base-swiper';
import styles from './index.less';
import Store from './store';
import { MECHA_INFO } from './config';

/**
 * fifthPage
 * @param store {fifthPageStore}
 * @returns {JSX.Element}
 * @constructor
 */
const FifPage = ({ store }) => {
  store.use();
  const { pageSwiperStore, indicatorSwiperStore, activeIndex } = store;

  const handleClick = e => {
    const id = e.target.getAttribute('data-mecha-id');
    if (!id) {
      return;
    }
    store.jumpDetail(id);
  };

  return (
    <div className={cx(styles.installationPartRoot)} onClick={handleClick}>
      {store.mechaList.length ? (
        <BaseSwiper store={pageSwiperStore}>
          {MECHA_INFO.map(item => {
            const { kv } = store.mechaList.find(i => i.mecha_id === item.id) || {};
            return (
              <div className={styles.slideItem} key={item.id}>
                {React.createElement(item.component, { isActive: true, mechaId: item.id, kvImg: kv })}
              </div>
            );
          })}
        </BaseSwiper>
      ) : null}
      <div className={styles.indicator}>
        <div className={styles.btnPrev} onClick={store.goPrev} />
        <BaseSwiper store={indicatorSwiperStore}>
          {MECHA_INFO.map((_, index) => {
            return (
              <div
                key={index}
                onClick={() => store.toSlideWithIndex(index)}
                className={cx(styles.indicatorItem, { [styles.isActive]: index === activeIndex })}
              />
            );
          })}
        </BaseSwiper>
        <div className={styles.btnNext} onClick={store.goNext} />
      </div>
    </div>
  );
};

export default wrapStore(FifPage, Store);
